<template>
  <div>
    <div class="senspro">
      <!-- <p v-for="(m,index) in planichlist" :key='index' title="查看大图" @click="fileclick(m)">
        {{m.fileName}}<a>查看大图</a>
      </p> -->

    <viewer :images="photo" class="seeBigImg">
      <img
        v-for="(src,index) in photo"
        :src="src"
        :key="index"
      >
    </viewer>

      <p v-if="planichlistss">没有上传平面图文件</p>
    </div>
    <el-dialog :visible.sync="dialogVisible" size="tiny">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>
<script>
import workbrnch from './../../data/emer/burst.js'
export default {
  data() {
    return {
      // 列表
      planichlist: null,
      planId: '',
      dialogVisible: false,
      dialogImageUrl: '',
      planichlistss: false,
      photo:[],
    }
  },
  created() {
    if (!sessionStorage.planIdLists) return
    this.planId = sessionStorage.planIdLists
    this.planich_list()
  },
  methods: {
    // 获取列表
    planich_list() {
      (async() => {
        try {
          let info = await workbrnch.planich_list({
            planId: this.planId
          })
          if (info.status && info.data) {
            this.planichlist = info.data
            for(var i = 0; i< this.planichlist.length; i++){
              let ImageUrl = `/api/emer/planich/download?id=${this.planichlist[i].id}&isOnline=true&num=${Math.random()}`;
              this.photo.push(ImageUrl)
            }
            if (this.planichlist.length < 1) {
              this.planichlistss = true
            }else{
              this.planichlistss = false
            }
          }
        } catch (err) {
          console.log(err)
        }
      })()
    },
    // 下载
    fileclick(m) {
      this.dialogVisible = true
      if(m.id){
        this.dialogImageUrl = `/api/emer/planich/download?id=${m.id}&isOnline=true&num=${Math.random()}`
      }
    },
  }
}

</script>
<style scoped lang="stylus">
.senspro {
  position: relative;
  overflow: auto;
  height: 588px;
  p {
    line-height: 35px;
    font-size: 16px;
    cursor: pointer;
    text-indent: 1em;
    a {
      font-size: 14px;
      padding-left: 10px;
      color: #20a0ff;
    }
  }
}
.seeBigImg{
  img {
    width:80px;
    height: 50px;
    object-fit:cover;
    cursor:pointer ;
  }
}

</style>



// WEBPACK FOOTER //
// planimg.vue?42ba2c3e